<template>
    <div class="app-container-height full-height">
        {{ value }}
    </div>
</template>

<script>
import getTaxYear from '@/lib/helpers/getTaxYear';

export default {
    name: 'Debug',
    data: () => ({
        value: getTaxYear('last', { asString: true })
    })
};
</script>
